// src/utils/constants.js

 export const BASE_URL = "https://booklenco-1.onrender.com";
//  export const BASE_URL = "http://localhost:2000";

export const theme = {
  primary:    '#5e35b1',
  primaryDark: '#4527a0',
  accent:     '#ffb300',
  accentDark: '#ff8f00',
  text:       '#1e1e2f',
  textLight:  '#4a4a68',
  bg:         '#fdfbfe',
  bgLight:    '#f8f5ff',
  surface:    '#ffffff',
  border:     '#e0d4ff',
  shadowSm:   '0 4px 12px rgba(69,39,160,0.12)',
  shadowMd:   '0 8px 24px rgba(69,39,160,0.18)',
};